import { render, staticRenderFns } from "./TabContents.vue?vue&type=template&id=56b874ec&scoped=true&"
import script from "./TabContents.vue?vue&type=script&lang=js&"
export * from "./TabContents.vue?vue&type=script&lang=js&"
import style0 from "./TabContents.vue?vue&type=style&index=0&id=56b874ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b874ec",
  null
  
)

export default component.exports